import { getBooleanRouteAttribute } from '@/root/shared-helpers/route-attributes/getBooleanRouteAttribute'
import type { SailPackage } from '@/root/shared-types/reservation/reservation-types'

export const ENABLE_HANDICAPPED_VEHICLES = 'ENABLE_HANDICAPPED_VEHICLES' as const

export const ENABLE_COMPANY_LOYALTIES = 'ENABLE_COMPANY_LOYALTIES' as const

/**
 * Whether the route sells the company-owned-vehicle discount, for cars and trailers alike.
 */
export const isCompanyLoyaltyEnabled = (sailPackage?: Pick<SailPackage, 'routeAttributes'>): boolean =>
  getBooleanRouteAttribute({ routeAttributes: sailPackage?.routeAttributes, key: ENABLE_COMPANY_LOYALTIES }) === true

/**
 * Whether the route sells the disability exemption for cars.
 */
export const isHandicappedVehiclesEnabled = (sailPackage?: Pick<SailPackage, 'routeAttributes'>): boolean =>
  getBooleanRouteAttribute({ routeAttributes: sailPackage?.routeAttributes, key: ENABLE_HANDICAPPED_VEHICLES }) === true
